// Soaki product page enhancements (loaded by sections/main-product.liquid with the Soaki layout):
// - a round "+" cursor that follows the pointer over product images and opens Dawn's lightbox on click,
// - the sale badge next to the title follows the selected variant.
// Everything lives inside the guard so loading the script twice (or re-rendering the section) is harmless.
if (!customElements.get('product-soaki')) {
  customElements.define(
    'product-soaki',
    class ProductSoaki extends HTMLElement {
      constructor() {
        super();
        this.pointer = { x: 0, y: 0 };
        this.frame = 0;
        this.cursor = null;

        this.onPointerMove = (event) => {
          // Mouse and pen hover only: touch has no cursor to replace.
          if (event.pointerType === 'touch') return;
          this.pointer.x = event.clientX;
          this.pointer.y = event.clientY;
          this.scheduleUpdate();
        };
        this.onPointerLeave = () => this.setActive(false);
        this.onScroll = () => {
          if (this.cursor?.classList.contains('is-visible')) this.scheduleUpdate();
        };
        this.onQueryChange = () => {
          if (!this.pointerQuery.matches) this.setActive(false);
        };
      }

      connectedCallback() {
        this.host = this.closest('product-info');
        if (!this.host) return;

        this.setupTitleBadge();

        if (this.dataset.zoomCursor === 'true') this.setupZoomCursor();
      }

      disconnectedCallback() {
        this.unsubscribeVariant?.();
        this.teardownZoomCursor();
      }

      // ---- Sale badge next to the title ----
      setupTitleBadge() {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.dataset.section) return;
          const badge = this.host.querySelector('[data-title-badge]');
          if (!badge) return;
          const variant = data.variant;
          badge.hidden = !(variant && variant.available && variant.compare_at_price > variant.price);
        });
      }

      // ---- Zoom cursor ----
      setupZoomCursor() {
        this.pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
        if (!this.pointerQuery.matches) return;

        this.cursor = document.createElement('span');
        this.cursor.className = 'soaki-zoom-cursor';
        this.cursor.setAttribute('aria-hidden', 'true');
        this.cursor.innerHTML = '<svg viewBox="0 0 14 14" focusable="false"><path d="M7 1.5v11M1.5 7h11"/></svg>';
        document.body.appendChild(this.cursor);

        this.host.addEventListener('pointermove', this.onPointerMove, { passive: true });
        this.host.addEventListener('pointerleave', this.onPointerLeave);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.pointerQuery.addEventListener('change', this.onQueryChange);
      }

      teardownZoomCursor() {
        if (!this.cursor) return;
        window.cancelAnimationFrame(this.frame);
        this.host?.removeEventListener('pointermove', this.onPointerMove);
        this.host?.removeEventListener('pointerleave', this.onPointerLeave);
        window.removeEventListener('scroll', this.onScroll);
        this.pointerQuery?.removeEventListener('change', this.onQueryChange);
        this.host?.classList.remove('has-zoom-cursor');
        this.cursor.remove();
        this.cursor = null;
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      }

      // Shows the cursor while the pointer is over an image that opens the lightbox, hides it elsewhere.
      update() {
        if (!this.cursor) return;
        const target = document.elementFromPoint(this.pointer.x, this.pointer.y);
        const overImage = Boolean(target?.closest('media-gallery .product__modal-opener--image'));
        this.setActive(overImage);
        if (overImage) {
          this.cursor.style.transform = `translate3d(${this.pointer.x}px, ${this.pointer.y}px, 0)`;
        }
      }

      setActive(active) {
        if (!this.cursor) return;
        this.cursor.classList.toggle('is-visible', active);
        this.host.classList.toggle('has-zoom-cursor', active);
      }
    }
  );
}
